import React from "react";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { googleplay, appstore, mobile1, mobile2 } from "../Constant/Index";
import { Link } from "react-router-dom";

const GetAppSection = ({ getapi }) => {
  return (
    <section className="get-app-sec">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="row">
              <div className="col-lg-7">
                <h2 className="main-heading-font dark-color text-white level-2 wow animate__animated animate__zoomIn">
                  {/* Get our app */}
                  {getapi?.sectionFive?.heading}
                </h2>
                <div className="pb-4">
                  <p className="primary-regular-font extra-color-5 text-white level-7">
                    {getapi?.sectionFive?.note}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 border-right">
                <h4 className="text-white primary-regular-font mb-3 mt-2 level-7">
                  Secure authentication
                </h4>
                <div>
                  <p className="primary-regular-font extra-color-5 text-white level-7">
                    {getapi?.sectionFive?.point_one}
                  </p>
                </div>
              </div>
              <div className="col-lg-6 border-right">
                <h4 className="text-white primary-regular-font mb-3 mt-2 level-7">
                  Secure authentication
                </h4>
                <div>
                  <p className="primary-regular-font extra-color-5 text-white level-7">
                    {getapi?.sectionFive?.point_two}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <a
                  href="signin"
                  className="btn log-in level-7 mt-4 primary-regular-font text-decoration-none"
                >
                  <span className="bg-wrapper">Download now</span>
                </a>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h2
                  className="main-heading-font dark-color text-white mt-5 level-3 wow animate__ animate__zoomIn animated"
                  style={{ visibility: "visible", animationName: "zoomIn" }}
                >
                  Available on
                </h2>
                <div className="d-flex align-items-center gap-3 mt-3">
                  <a href="">
                    <img src={googleplay} className="img-fluid" alt="" />
                  </a>
                  <a href="">
                    <img src={appstore} className="img-fluid" alt="" />
                  </a>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mobile-img">
                  <div className="row">
                    <div className="col-lg-6 mt-5">
                      <img src={mobile2} className="img-fluid" alt="" />
                    </div>
                    <div className="col-lg-6">
                      <img
                        src={mobile1}
                        className="img-fluid position-relative add-position"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetAppSection;
